import styled, { css } from 'styled-components';

type OverlayProps = {
  $isOpen: boolean;
};

type ContainerProps = {
  $isOpen: boolean;
};

export const Container = styled.div<ContainerProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  visibility: hidden;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      visibility: visible;
    `}
`;

export const Overlay = styled.div<OverlayProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #312f2e94;
  z-index: 12;
  opacity: 0;
  visibility: hidden;
  transition: all 0.6s;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      opacity: 0.5;
      visibility: visible;
    `}
`;

export const ModalContainer = styled.div`
  position: relative;
  z-index: 13;
  max-width: 759px;
  width: 80%;
  min-height: 568px;
  height: 75%;
  background: #ffffff;
  border-radius: 10px;
  padding: 32px;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  align-content: center;
`;

export const ModalTitleWrap = styled.div``;

export const ModalHeaderTitle = styled.h1`
  font-style: normal;
  font-weight: bold;
  font-size: 21px;
  line-height: 32px;
  color: #0013f5;
`;

export const ModalHeaderText = styled.span`
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 12px;
  color: #777880;
`;

export const ModalCloseButton = styled.button`
  background: transparent;
  border: none;
  outline: none !important;
`;

export const Separator = styled.div`
  border: 1px dashed rgba(0, 0, 0, 0.1);
  margin-top: 18px;
`;

export const Footer = styled.div`
  position: absolute;
  bottom: 0;
  background: #0013f5;
  width: 100%;
  height: 60px;
  left: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
`;

export const FooterText = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 21px;
  line-height: 32px;
  color: #ffffff;
`;

export const FooterHighLight = styled.span`
  color: #97f8fb;
`;

export const UllyImgContainer = styled.div``;

export const ImgUlly = styled.img`
  margin-left: 28px;
  margin-top: -56px;
  width: 80%;
  height: 80%;
`;
